import React from 'react';
import { cn } from '@/lib/utils';

export const GlassCard = React.forwardRef(
  ({ className, children, style, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('ns-glass rounded-[28px] p-5', className)}
      style={style}
      {...props}
    >
      {children}
    </div>
  )
);
GlassCard.displayName = 'GlassCard';

export default GlassCard;
